import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        <div className="bg-white rounded-lg shadow-lg p-8">
          <p className="text-gray-600">
            Terms of service content coming soon...
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
